module.exports = __webpack_public_path__ + "img/street-lamps-bw-thumb.1ee166bb.jpg";